/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./edit-version.vue?vue&type=template&id=5b64b3aa&scoped=true&"
import script from "./edit-version.vue?vue&type=script&lang=js&"
export * from "./edit-version.vue?vue&type=script&lang=js&"
import style0 from "./edit-version.vue?vue&type=style&index=0&id=5b64b3aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b64b3aa",
  null
  
)

export default component.exports